/* FOM · guia operacional — CASCA DE APRESENTACAO (gate 0075A).

   ATENCAO AO QUE ESTE ARQUIVO NAO CONTEM MAIS
   -------------------------------------------

   Ate o gate 0075A este arquivo carregava as 391 linhas do guia de UM cliente:
   as regras mandatarias numeradas, as fontes documentais, a divergencia entre
   documentado e observado, e as 127 assercoes com fonte. Tudo isso ia
   COMPILADO NO BUNDLE PUBLICO, e o lookup era guiaDe(external_id) — uma chave
   de no, sem organizacao.

   Nenhum codigo de regra, nome de documento ou observacao de cliente pode
   voltar a este arquivo, nem em comentario: o teste T69f varre todo o
   frontend e falha se encontrar. Se nao esta aqui, nao entra no bundle.

   O FOM-ARQ-0075 mostrou a consequencia: qualquer organizacao cujo mapa
   tivesse um no com o mesmo external_id recebia as regras da RMC. A politica
   de linha do banco nao pegava isso porque o conteudo nunca passava pelo
   banco.

   AGORA
   -----

   O conteudo vive no backend, ligado a organizacao, e chega por
   GET /orgs/:orgSlug/maps/:mapSlug/operational-guide, que so responde depois
   de a API verificar o vinculo de quem pede. Este arquivo guarda apenas os
   TIPOS e o catalogo que a sessao preencheu — que comeca VAZIO e continua
   vazio se o backend nao autorizar nada.

   O padrao e o mesmo ja usado pelo catalogo de tipos de no no gate 0073:
   definir<algo>() preenche em runtime, e o bundle nao carrega dado de cliente.

   NATUREZA DO CONTEUDO — inalterada. Segue sendo leitura curada de
   documentacao vigente, com fonte obrigatoria por item e teto epistemologico
   E2. Nenhum texto, fonte, classificacao ou semantica mudou no gate 0075A. */

/** Um item do guia: afirmacao curta + fonte documental obrigatoria. */
export type ItemGuia = { t: string; fonte: string };

/** Lacuna documental: a propria documentacao nao define. Vira pergunta
    investigavel — nao regra. */
export type LacunaDocumental = { pergunta: string; fonte: string };

/** Divergencia documentado × observado — o primeiro caso de inteligencia
    contextual (Fase 1V). NUNCA uma conclusao: os dois lados aparecem com as
    suas fontes e a saida e uma PERGUNTA investigavel. A interface nao pode
    dizer "regra violada" — quem decide e investigacao + decisao humana. */
export type Divergencia = {
  /** O que a regra escrita estabelece (E2). */
  documentado: ItemGuia;
  /** O que a evidencia registrada mostra (E1 deste mapa). */
  observado: ItemGuia;
  /** A pergunta operacional que a divergencia sugere — pre-preenchida no
      mecanismo de investigacao existente; nada e criado sem confirmacao. */
  pergunta: string;
};

export type EntradaGuia = {
  /** O QUE E — uma linha. */
  oQueE: ItemGuia;
  /** QUEM PARTICIPA — papeis conforme RACI da IT. */
  quem: ItemGuia;
  /** O QUE PRECISA EXISTIR antes (entradas). */
  precisaExistir: ItemGuia[];
  /** O QUE DEVE SER ENTREGUE (saidas). */
  entrega: ItemGuia[];
  /** O QUE ACONTECE DEPOIS (proxima etapa / handoff). */
  depois: ItemGuia;
  /** DOCUMENTOS E REGISTROS que a IT nomeia para a etapa. */
  registros: ItemGuia[];
  /** PONTOS DE ATENCAO — regras mandatarias (RG) que tocam a etapa. */
  atencao: ItemGuia[];
  /** O que a documentacao ainda NAO define ([DEFINIR] / decisao pendente). */
  lacunasDocumentais: LacunaDocumental[];
  /** Divergencias documentado × observado — opcional; so onde ha evidencia
      E1 REGISTRADA que nao fecha com a regra escrita. */
  divergencias?: Divergencia[];
};

/* Marcador de lacuna documental. E rotulo de INTERFACE, nao conteudo de
   cliente: nao nomeia documento, regra nem organizacao. Por isso continua no
   frontend. */
export const MARCA_AUSENTE = 'DEFINICAO AUSENTE NA DOCUMENTACAO';

/* ===================== catalogo preenchido em runtime ===================== */

/** O pacote que o backend entrega para a organizacao da sessao. */
export type PacoteGuia = {
  aviso: string | null;
  fontes: ItemGuia[];
  entradas: Record<string, EntradaGuia>;
};

/* Estado da sessao. COMECA VAZIO — sem carga autorizada, guiaDe() devolve null
   para qualquer external_id, inclusive os da RMC. */
let CATALOGO: Record<string, EntradaGuia> = {};

/* Exportados como `let` de proposito: em ESM o binding e vivo, entao quem ja
   importa AVISO_GUIA e FONTES_GUIA continua lendo o valor atual sem precisar
   mudar de forma. Ambos ficam vazios ate a carga autorizada. */
export let AVISO_GUIA = '';
export let FONTES_GUIA: ItemGuia[] = [];

/** Preenche o guia da sessao com o que o backend autorizou para esta
    organizacao. Chamar com pacote vazio ou null LIMPA — e o que deve acontecer
    ao trocar de organizacao ou ao encerrar a sessao. */
export function definirGuiaOperacional(pacote: PacoteGuia | null): void {
  CATALOGO = pacote?.entradas ?? {};
  AVISO_GUIA = pacote?.aviso ?? '';
  FONTES_GUIA = pacote?.fontes ?? [];
}

/** Guia da etapa, se a organizacao da sessao tem cobertura — null caso
    contrario. Sem carga autorizada, sempre null. */
export function guiaDe(externalId: string): EntradaGuia | null {
  return CATALOGO[externalId] ?? null;
}

/** Ids cobertos (para testes e contagens — nunca para inventar cobertura). */
export function idsComGuia(): string[] {
  return Object.keys(CATALOGO);
}
